import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeadSub from '../../../components/comm/HeadSub';
import URL from '../../../constants/url';
import style from './ContactlessNotifi.module.css';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

import noDataImg from '../../../images/common/i_3d_no_data_doc.svg';



// 환자 > 알림 소스 가지고 옴 - 수정 필요 !!!!!!!!!!!!!!   


// 공통 알림 리스트 컴포넌트
const NotificationListComponent = ({ notifications, onItemClick, loading }) => {
    // 중요 알림인지 확인하는 함수 - imprtAt 필드 기반으로 변경
    const isImportantNotification = (item) => {
        console.log('imprtAt 값:', item.imprtAt, typeof item.imprtAt); // 디버깅용
        return String(item.imprtAt) === '1';
    };

    return (
        <div className={style['alarm-list-box']}>
            <div className="list-wrap" data-style="2" data-line='under'>
                <ul>
                    <li>
                        <div className="list-inner-box no-check">
                            <div className="txt-box hit">
                                <span className="top-tit">New Consultation</span>
                                <strong line-clamp="3">
                                    Your remote consultation request has been received. Please check the schedule in the app.
                                </strong>
                                <p>
                                </p>
                                <span className="date">2024.12.25_14:00</span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="list-inner-box no-check">
                            <div className="txt-box hit">
                                <span className="top-tit">Schedule Changed</span>
                                <strong line-clamp="3">
                                    Your consultation schedule has been changed. Please check the new schedule.
                                </strong>
                                <p>
                                </p>
                                <span className="date">2024.12.25_14:00</span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="list-inner-box no-check">
                            <div className="txt-box">
                                <span className="top-tit">Consultation Canceled</span>
                                <strong line-clamp="3">
                                    Your consultation has been canceled. Please rebook if necessary.
                                </strong>
                                <p>
                                </p>
                                <span className="date">2024.12.25_14:00</span>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className="list-inner-box no-check">
                            <div className="txt-box">
                                <span className="top-tit">3-Day Reminder</span>
                                <strong line-clamp="3">
                                    Your consultation is scheduled in 3 days.
                                </strong>
                                <p>
                                </p>
                                <span className="date">2024.12.25_14:00</span>
                            </div>
                        </div>
                    </li>



                    {/* 데이터 없을시  */}
                    {/* <li>
                        <div className={style['no-data-box']}>
                            <div className={style['img-box']}>
                            <object data={noDataImg}></object>
                            </div>
                            <p>No Data</p>
                        </div>
                    </li> */}


                </ul>
                <div className={style['line-notice-box']}>
                    <span>You can only view notifications <br/> from the past 30 days.</span>
                </div>
            </div>
        </div>
    );
};


const ContactlessNotifi = () => {
    const navigate = useNavigate();

    const [pushAlarm, setPushAlarm] = useState(true);
    const [isInitialLoading, setIsInitialLoading] = useState(true);

    const handlePushToggle = (value) => {
        setPushAlarm(value);
    };

    //  스켈레톤 리스트 추가
    const renderSkeletons = () => {
        return Array.from({ length: 5 }).map((_, index) => (
            <li key={`skeleton-${index}`}>
                <div className="list-inner-box no-check">
                    <div className="txt-box">
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1,
                            }}
                        >
                            <Skeleton variant="text" width="70%" height={24} />
                            <Skeleton variant="text" width="50%" height={20} />
                            <Skeleton variant="text" width="40%" height={18} />
                        </Box>
                    </div>
                </div>
            </li>
        ));
    };

    // 알림 아이템 클릭 핸들러
    const handleNotificationClick = (item) => {
        console.log('클릭된 알림:', item);
        // 추후 상세보기나 다른 액션 구현
        // 전체발송테스트();
    };

    return (
        <>
            <HeadSub title="Notification" />

            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">
                    {/* {isInitialLoading ? (
                        <div className={style['alarm-list-box']}>
                            <div className="list-wrap" data-style="2">
                                <ul>{renderSkeletons()}</ul>
                            </div>
                        </div>
                    ) : ( */}
                        <NotificationListComponent
                            onItemClick={handleNotificationClick}
                        />
                    {/* )} */}
                </div>
            </div>
        </>
    );
};

export default ContactlessNotifi;
